

















import { createComponent, PropType, computed } from '@vue/composition-api'

export default createComponent({
  name: 'AppSelect',
  props: {
    value: {
      type: null,
      required: true
    },
    items: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Array as PropType<{ text: string, value: any }[]>,
      required: true
    }
  },
  setup (props, context) {
    const inputValue = computed({
      get: () => props.value,
      set: (value) => context.emit('input', value)
    })

    return {
      inputValue
    }
  }
})
